import { render, staticRenderFns } from "./Colegio.vue?vue&type=template&id=19f6d22d&scoped=true"
import script from "./Colegio.vue?vue&type=script&lang=js"
export * from "./Colegio.vue?vue&type=script&lang=js"
import style0 from "./Colegio.vue?vue&type=style&index=0&id=19f6d22d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f6d22d",
  null
  
)

export default component.exports